import * as orderApi from '../../api/orderApi'

const state = {
    serviceCodeOrderDetail: {},
    forceReceivingServiceOrder:{},
		douyinserviceCodeOrderDetail: {},
    getImgVerifyCodeByCode:{},
		reSendServiceCode: {},
		ksCertificatePrepareResult: {}
}
const actions = {
    async GetServiceOrderDetailByServiceCode({ commit }, order) {
        const response = await orderApi.GetServiceOrderDetailByServiceCode(order);
        commit('setServiceOrderDetailByServiceCode', response);
        return response;
    },
    async ForceReceivingServiceOrder({ commit }, order) {
        const response = await orderApi.ForceReceivingServiceOrder(order);
        commit('setForceReceivingServiceOrder', response);
        return response;
    },
    async ForceReceivingServiceOrder({ commit }, order) {
        const response = await orderApi.ForceReceivingServiceOrder(order);
        commit('setForceReceivingServiceOrder', response);
        return response;
    },
    async GetImgVerifyCodeBySign({ commit }, order) {
        const response = await orderApi.GetImgVerifyCodeBySign(order);
        commit('setImgVerifyCodeBySign', response);
        return response;
    },
    async ReSendServiceCode({ commit }, order) {
        const response = await orderApi.ReSendServiceCode(order);
        commit('setReSendServiceCode', response);
        return response;
    },
		async DouYinCertificatePrepare({ commit }, order) {
		    const response = await orderApi.DouYinCertificatePrepare(order);
		    commit('setDouYinCertificatePrepare', response);
		    return response;
		},
		async DouYinVerifyCertificate({ commit }, order) {
		    const response = await orderApi.DouYinVerifyCertificate(order);
		    commit('setDouYinVerifyCertificate', response);
		    return response;
		},
		//快手验券准备
  	async KsCertificatePrepare({ commit }, request) {
				const response = await orderApi.KsCertificatePrepare(request);
				commit('setKsCertificatePrepare', response);
				return response;
		}
  }

const mutations = {

		setKsCertificatePrepare(state, data) {
				state.ksCertificatePrepareResult = data;
		},

    setServiceOrderDetailByServiceCode(state, data) {
        state.serviceCodeOrderDetail = data;
    },
    setForceReceivingServiceOrder(state, data) {
        state.forceReceivingServiceOrder = data;
    },
    setImgVerifyCodeBySign(state, data) {
        state.getImgVerifyCodeByCode = data;
    },
    setReSendServiceCode(state, data) {
        state.ReSendServiceCode = data;
    },
		setDouYinCertificatePrepare(state, data) {
		    state.douyinserviceCodeOrderDetail = data;
		},
		setDouYinVerifyCertificate(state, data) {
		    state.forceReceivingServiceOrder = data;
		}
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/servicescodeorder.js